import { Box, Button, Container, Grid, Input, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import Bottom from "../../Bottom";
import { useEffect } from "react";
import api from "../../../utils/api_v2";
import LodingData from "../../../utils/LodingData";

import useStressStore from "../../../store/stressStores";
import { useLocation, useNavigate } from "react-router-dom";

import $ from 'jquery';
import tabbg from "../../../assets/images/tab_01.png"

const StressAnswer = () => {

  const storeData: any = useStressStore();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    getQuestionsList();

    return () => {
      // storeData.clear();
    }
  }, [])

  useEffect(() => {

    genRowspan('category');

  }, [storeData.questionsList])

  function getQuestionsList() {
    let userId: any = localStorage.getItem('userID');

    LodingData(() => api.get(`customer/api/v2/surveys/${location.state.survey_uid}/assigns/${location.state.assigned_uid}`, { headers: { 'userId': userId } })
      .then(res => {
        // console.log(res);
        // storeData.setQuestionsList(res.data.data);

        const tempList = [];
        for (let i = 0; i < res.data.data.info.length; i++) {
          const { category, question } = res.data.data.info[i];
          const tempObj: any = {};
          tempObj.category = category.name;
          tempObj.category_uid = category.uid;
          tempObj.category_number = category.number;

          tempObj.number = question.number;
          tempObj.title = question.title;
          tempObj.question_uid = question.uid;
          tempObj.type = question.type;

          tempObj.strongly_disagree = question.option.strongly_disagree;
          tempObj.disagree = question.option.disagree;
          tempObj.agree = question.option.agree;
          tempObj.strongly_agree = question.option.strongly_agree;

          tempList.push(tempObj);
        }

        storeData.setQuestionsList(tempList);
      })
      .catch(err => {
        console.log(err);
      }));
  }

  // 카테고리 rowspan 함수
  const genRowspan = (className: string) => {
    const elements = Array.from(
      document.querySelectorAll(`.${className}`)
    ) as HTMLTableCellElement[];
    let lastCategory = "";
    let rowspan = 1;
    let firstElement: HTMLTableCellElement | null = null;

    elements.forEach((element) => {
      const text = element.textContent;

      if (text === lastCategory) {
        rowspan++;
        element.style.display = "none";
        if (firstElement) {
          firstElement.setAttribute("rowspan", rowspan.toString());
        }
      } else {
        lastCategory = text || "";
        rowspan = 1;
        firstElement = element;
        element.removeAttribute("rowspan");
        element.style.display = "";
      }
    });
  };

  // 설문 제출하기
  function handleSubmitSurvey() {
    let valueStatus = true;
    const answer = [];
    const dLen = storeData.questionsList.length;

    for (let i = 0; i < dLen; i++) {
      const d = storeData.questionsList[i];
      const input = $(`input[name="${d.question_uid}"]${d.type !== 'text' ? ':checked' : ''}`);
      const value = $(input).val();

      valueStatus &&= !!value;
      if (!!!value) {
        $(`#stress-${d.number}`).children('td').not('.category').addClass('focusing');
        $(`#stress-${d.number}`).focus();
      }
      answer[d.number - 1] = { question: { uid: d.question_uid }, answer: $(input).val() };
    }

    if (!valueStatus) {
      alert("문항에 대한 응답을 모두 선택해주세요.");
    } else {
      const requestBody = {
        family: {
          id: localStorage.getItem('ownerFamID')
        },
        QnAs: answer,
        year: new Date().getFullYear(),
        uid: location.state.assigned_uid
      }

      LodingData(() => api.post(`customer/api/v2/surveys/assigns/${location.state.assigned_uid}`, requestBody)
        .then(res => {
          // console.log(res);
          if (res.data.success === false) {
            alert(res.data.message);
          } else if (res.data.success === true) {
            alert('저장되었습니다.');
          }
          navigate('/stress')
        })
        .catch(err => {
          console.log(err);
        }));
    }
  }

  // 포커스
  function handleChange(e: any) {
    if (!$(e).is(":checked")) {
      $(e.target).closest('td').removeClass('focusing');
      $(e.target).closest('td').siblings().removeClass('focusing');
    }
  }


  return (
    <Container className="container" sx={{ mb: 5 }}>
      <Box sx={img} >
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#8acd83', fontWeight: 900, }}>
              직무스트레스
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ead3d', fontWeight: 500, }} gutterBottom>
              한국인 직무 스트레스 측정도구(Korean Occupational Stress Scale: KOSS)
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ width: 1500 }}>
        <TableContainer className="White_box">
          <Table size="small" className="Cl_table" sx={{ whith: '100%', '& td': { borderRight: '1px solid #ccc', cursor: 'default', '& input': { cursor: "pointer" } } }}>
            <TableHead>
              <TableRow>
                <TableCell>구분</TableCell>
                <TableCell sx={{ width: 50 }}>#</TableCell>
                <TableCell>내용</TableCell>
                <TableCell sx={{ width: 110 }}>전혀<br />그렇지 않다</TableCell>
                <TableCell sx={{ width: 110 }}>그렇지 않다</TableCell>
                <TableCell sx={{ width: 110 }}>그렇다</TableCell>
                <TableCell sx={{ width: 110 }}>매우 그렇다</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                storeData.questionsList && storeData.questionsList.map((item: any, idx: number) => {
                  return (
                    <TableRow key={idx} id={`stress-${item.number}`}>
                      <TableCell className="category">{item.category}</TableCell>
                      <TableCell>{item.number}</TableCell>
                      <TableCell>{item.title}</TableCell>
                      <TableCell>
                        <Input name={item.question_uid} type={item.type} value={item.strongly_disagree} onChange={handleChange} sx={{ '&::before': { border: '0px solid #ccc' } }} />
                      </TableCell>
                      <TableCell>
                        <Input name={item.question_uid} type={item.type} value={item.disagree} onChange={handleChange} sx={{ '&::before': { border: '0px solid #ccc' } }} />
                      </TableCell>
                      <TableCell>
                        <Input name={item.question_uid} type={item.type} value={item.agree} onChange={handleChange} sx={{ '&::before': { border: '0px solid #ccc' } }} />
                      </TableCell>
                      <TableCell>
                        <Input name={item.question_uid} type={item.type} value={item.strongly_agree} onChange={handleChange} sx={{ '&::before': { border: '0px solid #ccc' } }} />
                      </TableCell>
                    </TableRow>
                  )
                })
              }
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Box sx={{ textAlign: 'center' }}>
        <Typography sx={{ color: 'red' }}>! 제출 후에는 수정할 수 없습니다.</Typography>
        <Button variant="contained" onClick={handleSubmitSurvey} sx={{ mt: 2, background: '#0d6703', borderRadius: 20, width: '20%', '&:hover': { background: '#074300' } }}>제출하기</Button>
      </Box>

      <Bottom />
    </Container>
  )
}


const img = {
  display: 'flex', p: 0, backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}
export default StressAnswer;